import React from 'react';

import EditPromptForm from '../shared/EditPromptForm';

export default function EditWorkspacePrompt() {
  return (
    <EditPromptForm
      targets={[{ name: 'Workspace', id: 'Summarization' }]}
      promptLabel='Workspace'
      backPath='/admin/workspace-prompts'
    />
  );
}
